export default interface Rect {
  x:number,
  y:number,
  width:number,
  height:number
}